const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/carGalleries.json`)
const carGalleries = [...data]

export default carGalleries